'use strict';

var promisify = require('promisify-es6');

var pump = require('pump');

var Writable = require('readable-stream').Writable;

var moduleConfig = require('./utils/module-config');

var PingMessageStream = require('./utils/ping-message-stream');

module.exports = function (arg) {
  var send = moduleConfig(arg);
  return promisify(function (id, opts, callback) {
    if (typeof opts === 'function') {
      callback = opts;
      opts = {};
    }

    if (opts.n && opts.count) {
      return callback(new Error('Use either n or count, not both'));
    } // Default number of packtes to 1


    if (!opts.n && !opts.count) {
      opts.n = 1;
    }

    var request = {
      path: 'ping',
      args: id,
      qs: opts
    }; // Transform the response stream to a value:
    // [{ success: <boolean>, time: <number>, text: <string> }]

    var transform = function transform(stream, callback) {
      var messageConverter = new PingMessageStream();
      var responses = [];
      pump(stream, messageConverter, new Writable({
        objectMode: true,
        write: function write(chunk, enc, cb) {
          responses.push(chunk);
          cb();
        }
      }), function (err) {
        if (err) {
          return callback(err);
        }

        callback(null, responses);
      });
    };

    send.andTransform(request, transform, callback);
  });
};